<template>
  <v-row dense>
    <v-col cols="12">
      <text-field-like
          :value="processImplementation.name"
          label="プロセス名">
      </text-field-like>
    </v-col>
    <v-col cols="12">
      <text-field-like
          v-if="readonly"
          :value="eventImplementationView.name"
          label="イベント名"
          placeholder="未設定">
      </text-field-like>
      <v-text-field
          v-else
          v-model="eventImplementationView.name"
          label="イベント名"
          autofocus>
      </v-text-field>
    </v-col>
    <v-col cols="12">
      <local-id-field
          v-if="readonly"
          label="内部ID"
          :value="eventImplementationView.localId">
      </local-id-field>
      <v-text-field
          v-else
          v-model="eventImplementationView.localId"
          label="内部ID"
          :rules="[
              v => !!v || '内部IDが必要です',
              v => !existsLocalId(v) || '既に存在する内部IDです'
            ]">
      </v-text-field>
    </v-col>
    <v-col cols="12">
      <text-field-like
          v-if="readonly"
          :value="eventImplementationView.description"
          label="説明"
          placeholder="未設定"
          multi-line>
      </text-field-like>
      <v-textarea
          v-else
          v-model="eventImplementationView.description"
          label="説明"
          messages="複数行入力可"
          rows="1"
          auto-grow>
      </v-textarea>
    </v-col>

    <!-- readonly 時の記録関連 -->
    <template v-if="readonly">
      <v-col cols="12">
        <text-field-like
            :value="eventImplementationView.isMonitored ? '記録する' : '記録しない'"
            label="記録">
        </text-field-like>
      </v-col>
      <v-col v-if="eventImplementationView.isMonitored" cols="12">
        <text-field-like
            :value="eventImplementationView.monitoringContent"
            label="記録内容"
            placeholder="未設定"
            multi-line>
        </text-field-like>
      </v-col>
    </template>

    <!-- editable 時の記録関連 -->
    <template v-else>
      <v-col cols="12" class="mt-3">
        <v-card outlined>
          <v-card-title style="padding-top: 0; padding-bottom: 1rem;">
            <v-checkbox
                :input-value="eventImplementationView.isMonitored"
                label="記録"
                @change="eventImplementationView.isMonitored = $event"
                hide-details>
              <template #append>
                <el-tooltip :open-delay="500">
                  <template #content>
                    チェックすると実行内容を記録し、コントローラへ通知すること意味します
                  </template>
                  <template #default>
                    <v-icon small color="primary" style="top: 3px;">mdi-help-circle</v-icon>
                  </template>
                </el-tooltip>
              </template>
            </v-checkbox>
          </v-card-title>
          <v-card-text>
            <v-textarea
                v-model="eventImplementationView.monitoringContent"
                label="記録内容 "
                messages="複数行入力可"
                :disabled="!eventImplementationView.isMonitored"
                rows="1"
                auto-grow>
            </v-textarea>
          </v-card-text>
        </v-card>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import LocalIdField from "@/components/molecules/LocalIdField.vue";
export default {
  name: 'EventImplementationCreateForm',
  components: {LocalIdField, TextFieldLike},
  model: {
    prop: 'eventImplementation',
    event: 'change-form'
  },
  props: {
    processImplementation: {
      type: Object,
      required: true,
    },
    eventImplementations: {
      type: Array,
      required: false,
      default: () => ([])
    },
    eventImplementation: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      eventImplementationView: {}
    }
  },
  methods: {
    existsLocalId(localId) {
      return localId !== this.eventImplementation.localId &&
          this.eventImplementations.some(ei => ei.localId?.trim() === localId?.trim())
    }
  },
  watch: {
    eventImplementation: {
      immediate: true,
      handler(value) {
        this.eventImplementationView = value;
      }
    },
    eventImplementationView: {
      deep: true,
      handler() {
        this.$emit('change-form', this.eventImplementationView)
      }
    }
  }
}
</script>
